var _path, _g, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpertSupport = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 101,
    viewBox: "0 0 99 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_187",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 99,
    height: 101
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H98.247V100.37H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_187)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9075 33.144H87.6585C87.3835 30.074 86.4055 23.858 82.9375 17.579C74.9115 3.05 60.1195 0 49.1235 0C38.1275 0 23.3355 3.05 15.3095 17.579C11.8415 23.858 10.8635 30.074 10.5885 33.144H4.33951C1.94651 33.144 -0.000488281 35.091 -0.000488281 37.484V61.288C-0.000488281 63.681 1.94651 65.628 4.33951 65.628H10.8015C11.3165 68.99 12.5015 73.899 15.2365 78.849C20.7205 88.777 29.3635 93.343 37.7955 95.241V96.52C37.7955 98.643 39.5235 100.37 41.6465 100.37H56.4535C58.5765 100.37 60.3035 98.643 60.3035 96.52V92.847C60.3035 90.724 58.5765 88.997 56.4535 88.997H41.6465C39.6775 88.997 38.0515 90.483 37.8255 92.392C28.7825 90.252 22.0445 85.308 17.7455 77.586C14.3595 71.505 13.5035 65.338 13.2865 62.678V53.223V49.554H15.6455C15.9535 49.554 16.2045 49.305 16.2075 48.997C16.2075 48.932 16.2945 42.389 19.0745 35.845C22.7635 27.161 29.2115 22.579 38.2405 22.228C58.2425 21.45 63.6985 14.329 64.7695 12.513C84.1995 16.595 81.8485 48.622 81.8225 48.947C81.8095 49.104 81.8625 49.258 81.9685 49.373C82.0755 49.489 82.2245 49.554 82.3815 49.554H84.9605V53.223V65.628H93.9075C96.3005 65.628 98.2475 63.681 98.2475 61.288V37.484C98.2475 35.091 96.3005 33.144 93.9075 33.144",
    fill: "#F68D1F"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4165 71.2267C45.4935 71.2267 40.7045 70.3507 36.5685 68.6927C35.8485 68.4047 35.4995 67.5867 35.7875 66.8677C36.0755 66.1487 36.8925 65.7987 37.6125 66.0867C41.4205 67.6127 45.8475 68.4197 50.4165 68.4197C55.1685 68.4197 59.7435 67.5527 63.6465 65.9117C64.3605 65.6117 65.1845 65.9467 65.4845 66.6617C65.7845 67.3767 65.4495 68.1997 64.7345 68.4997C60.4895 70.2837 55.5385 71.2267 50.4165 71.2267",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4651 41.5504C41.4651 43.8664 39.5871 45.7444 37.2711 45.7444C34.9551 45.7444 33.0781 43.8664 33.0781 41.5504C33.0781 39.2344 34.9551 37.3564 37.2711 37.3564C39.5871 37.3564 41.4651 39.2344 41.4651 41.5504",
    fill: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1082 41.5504C68.1082 43.8664 66.2302 45.7444 63.9142 45.7444C61.5982 45.7444 59.7212 43.8664 59.7212 41.5504C59.7212 39.2344 61.5982 37.3564 63.9142 37.3564C66.2302 37.3564 68.1082 39.2344 68.1082 41.5504",
    fill: "#333333"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpertSupport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ExpertSupport.54eda3a640ca7f67c09f3182016a5f43.svg";